import { Vue, Component, Prop, Watch, Emit } from "vue-property-decorator";
import { Getter } from "vuex-class";

import CrudGrid from '@/../bower_components/teknisavuecomponents/components/grids/CrudGrid.vue';

import InlineGrid from '@/../bower_components/teknisavuecomponents/components/grids/inline-grid/InlineGrid.vue';
import HttpRequest from "@/../bower_components/teknisavuecomponents/assets/utils/HttpRequest";
import Time from "@/../bower_components/teknisavuecomponents/assets/utils/Time";
import Util from "@/../bower_components/teknisavuecomponents/assets/utils/Util";
import FileUtils from "@/../bower_components/teknisavuecomponents/assets/utils/FileUtils";
import SnackbarUtils from "@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils";
import { OcorrenciaController } from "@/assets/ts/controller/OcorrenciaController";

@Component({
  name: 'itemSolicitacaoPopup',
  components: {
    CrudGrid,
  }
})
class itemSolicitacaoPopup extends Vue {
  // #region [ PROPS ]
  @Prop({ required: true })
  private readonly nrsolicitacao: any;

  @Prop({ default: 0 })
  private readonly triggerReload: number;

  @Prop({ default: false })
  private readonly value: boolean;
  // #endregion

  // #region [ STORE ]
  @Getter('periodoDemonstrativoAtual')
  private periodoDemonstrativoAtual: any;
  // #region [ EVENTS ]
  @Emit('input')
  private emitInput(show: boolean) {}
  // #endregion

  // #region [ DATA ]
  private routeItensSoli = 'getItemSolicitacao';


  private loading = false;

  private columns = [
    {
      text: 'Solicitação',
      value: 'NMTIPOSOLICITACAO',
      name: 'NMTIPOSOLICITACAO',
      cols: 6,
      tag: 'v-text-field',
      required: true,
      showOnList: true,
    },
    {
      text: 'Nr. Item',
      value: 'NRITEMSOLICITACAO',
      type: 'number',
      cols: 2,
      tag: 'v-text-field',
      required: false,
      showOnList: false,
    },
    {
      text: 'Descrição do Item',
      value: 'DSLABELITEMSOLI',
      type: 'text',
      cols: 5,
      tag: 'v-text-field',
      required: false,
      showOnForm: true,
    },
    {
      text: 'Valor do Item',
      value: 'DSVALORITEMSOLI',
      type: 'text',
      cols: 5,
      tag: 'v-text-field',
      required: false,
      showOnForm: true,
    },
  ];

  private nameRow: string = "Itens da Solicitação";

  private showDialog: boolean = false;

  private triggerReloadTable = 0;

  private readonly PopUpButtonsOcorrencia = [];

  private actionsItem = [];

  private toolbarActionsOcorrencia = [
    'reload',
  ];
  //#endregion

  // #region [ COMPUTED ]
  private get user() {
    return this.$store.getters.user;
  }

  private get filtersItem() {
    if (!this.user) {
      return null;
    }
    const filters = {
      NRORG: this.user.nrorg,
      NRSOLICITACAO: this.nrsolicitacao,
    };

    return filters;
  }


  private get dialogTitle(): string {
    const title = 'Itens da Solicitação';

    return title;
  }
  // #endregion

  // #region [ WATCHERS ]
  @Watch('value', { immediate: true })
  private valueOnChange() {
    this.showDialog = this.value;
  }

  @Watch('triggerReload')
  private triggerReloadOnChange() {
    this.reloadGrid();
  }
  // #endregion

  // #region [ METHODS ]

  private closeItemsCard(){
    this.showDialog = false;

    this.emitInput(this.showDialog);
  }

  private reloadGrid() {
    this.triggerReloadTable++;
  }


  //#endregion
}

export default itemSolicitacaoPopup;